import { computed, inject, Injectable } from '@angular/core';

import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly oidc = inject(OidcSecurityService);

  public user = computed(() => this.oidc.userData()?.userData);

  public entityId = computed(() => this.user()?.sub);
  public userName = computed(() => this.user()?.name);
  public email = computed(() => this.user()?.email);

  public fullName = computed(() => {
    const userData = this.user();
    return userData ? `${userData.given_name} ${userData.family_name}` : '';
  });
}
